import { Loading } from '@/components/ui/old/Loading';
import { useCurrentAsset } from '@/hooks/use-current-asset';

import { useSiteMapFilters } from '../hooks/use-filters';
import { useSitesList } from '../hooks/use-sites-list';

import { SiteView } from './site-view';

export function SiteMapContent() {
  const { asset } = useCurrentAsset();
  const [{ siteIds = [] }] = useSiteMapFilters();
  const sitesList = useSitesList({
    siteIds: asset ? [asset.fullFrontendId] : siteIds,
  });

  if (sitesList.isLoading) {
    return <Loading />;
  }

  if (sitesList.isError) {
    throw sitesList.error;
  }

  if (!sitesList.data) {
    return <div>no data</div>;
  }

  return (
    <>
      <div className="grid w-full grid-cols-1 justify-start gap-4 gap-y-10 xl:grid-cols-2">
        {sitesList.data.map((site) => (
          <SiteView key={site.id} site={site} />
        ))}
      </div>
    </>
  );
}
